import { useTranslation } from 'next-i18next'
// Dependencies.
import { useState, useMemo } from 'react'

import { icons } from '../../../utils'
import { EventHookInterface, Equipment } from '../../../types'
import { ListItemInput } from '../../ListItemInput'
import { SectionField } from '../../Inputs/SectionField'

// Props.
interface Props {
  eventHook: EventHookInterface
}

// What To Bring.
export const WhatToBring: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Event.
  const { eventHook } = props
  const { isEditable } = eventHook
  const event = eventHook.value
  const emptyEquipment: Equipment = { descr: '' }

  // What To Bring.
  const whatToBring = useMemo(() => {
    if (!event.equipments || !event.equipments.length) return [emptyEquipment] // Empty String Only.
    const lastItemIsEmptyString =
      event.equipments[event.equipments.length - 1].descr === ''
    if (!lastItemIsEmptyString) return [...event.equipments, emptyEquipment]
    return [...event.equipments]
  }, [event])

  // Add Item Add Index.
  const addItemAtIndex = (index: number) => {
    eventHook.updateFieldsWithPartial({
      equipments: [
        ...whatToBring.slice(0, index + 1),
        emptyEquipment,
        ...whatToBring.slice(index + 1),
      ],
    })
  }

  // Handle Backspace At Index.
  const handleBackspaceAtIndex = (index: number) => {
    const equipments = [...whatToBring]
    const target = equipments[index]
    if (!target.descr) equipments.splice(index, 1)
    eventHook.updateFieldsWithPartial({ equipments })
  }

  // On Change At Index.
  const onChangeAtIndex = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const equipments = [...whatToBring]
    equipments[index].descr = event.target.value
    eventHook.updateFieldsWithPartial({ equipments })
  }

  // On Key Down At Index.
  const onKeyDownAtIndex = (
    event: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    const backspaceWasPressed = event.keyCode === 8
    const enterKeyWasPressed = event.keyCode === 13
    if (backspaceWasPressed) return handleBackspaceAtIndex(index)
    if (enterKeyWasPressed) return addItemAtIndex(index)
  }

  // ..
  if (
    !whatToBring.length ||
    (whatToBring.length === 1 && whatToBring[0].descr === '')
  )
    return null
  return (
    <SectionField
      header={t(`What to bring`, `What to bring`)}
      // subheader={isEditable && "Add a step-step, or a list of instructions your participants will follow during the event"}
    >
      {/* Added Item. */}
      {whatToBring.map((item, index) => (
        <ListItemInput
          icon={(item && icons.tickInsideCircle) || icons.plusInsideCircle}
          key={index}
          onBlur={() => handleBackspaceAtIndex(index)}
          onChange={(e) => onChangeAtIndex(e, index)}
          onKeyDown={(e) => onKeyDownAtIndex(e, index)}
          placeholder={t(`Add bullet point`, `Add bullet point`)}
          // readOnly={!isEditable}
          readOnly={true}
          value={item.descr}
        />
      ))}
    </SectionField>
  )
}
